export function clean_email(email: string): TEmail {
  const normalized = email.trim().toLowerCase();

  const valid = normalized.match(/[^@]+@[^@]+\.[^@]+/);

  if (!valid) {
    throw new Error(`Invalid email: ${email}`);
  }

  return normalized as TEmail;
}

export function format_phone(value: string) {
  return value
    .replace('+1', '')
    .replace(/\D+/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}

export function capitalize(text: string): string {
  const [head, ...tail] = text;

  return `${head.toUpperCase()}${tail.join('')}`;
}

/**
 * For text placed BETWEEN tags. Quotes are left alone: they are only
 * markup inside an attribute, and escaping them puts `&#39;` in front of
 * anyone whose client shows the text raw.
 */
export function escape_html_text(value: string): string {
  return value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;');
}

/** For text placed between tags OR inside a double-quoted attribute. */
export function escape_html(value: string): string {
  return escape_html_text(value).replaceAll('"', '&quot;');
}

/**
 * Typed text as the lines to show: any line ending counts once, trailing
 * spaces go, blank lines at either end go, and a run of blank lines is one
 * blank line — a customer's stray Enter is not three empty rows.
 */
export function text_lines(value: string): string[] {
  const lines: string[] = [];

  for (const line of value.split(/\r\n|\r|\n/).map((l) => l.trimEnd())) {
    if (line === '' && (lines.length === 0 || lines[lines.length - 1] === '')) {
      continue;
    }

    lines.push(line);
  }

  if (lines[lines.length - 1] === '') {
    lines.pop();
  }

  return lines;
}
